export default "__VITE_ASSET__Cd$482ff__"